// @flow
import {
    AD_ID,
    MID_AD_BANNER_MOBILE,
    MID_AD_TOWER,
    MID_AD_TOWER_2,
    SERP_INLINE_ADS,
    RIGHT_RAIL_AD_VIEWPORT_MIN_WIDTH,
    RIGHT_RAIL_AD_XL_VIEWPORT_MIN_WIDTH
} from '../../../constants/ads';
import {VRBO} from '../../../constants/sites';
import {
    HA_ADS_NATIVE_UNIT_SERP_DESKTAB,
    HA_ADS_NATIVE_UNIT_SERP_MOBILE,
    HA_ADS_SERP_RIGHTRAIL_300X600
} from '../../../abacus/experiments';
import {
    evaluateExperimentAndLog,
    evaluateAllExperiments
} from '@homeaway/abacus-client-utils';

type GoogleAdConfig = {
    container: string,
    colorText: string,
    colorDomainLink: string,
    colorTitleLink: string,
    colorBackground: string,
    fontSizeTitle: number,
    fontSizeDescription: number,
    fontSizeDomainLink: number,
    longerHeadlines: boolean,
    detailedAttribution: boolean,
    number: number
};

type AdSenseConfigData = {
    isMobile: boolean,
    siteName: string,
    screenWidth: number
};

type hadFuncsObject = {
    init: Function,
    addAdSlot: Function,
    displayAds: Function,
    setABTestsEvaluation: Function
};

let hadvertising;

export function onHAdvertisingReady(hadFuncs: hadFuncsObject) {
    hadFuncs.init();

    const allExperiments = evaluateAllExperiments();
    hadFuncs.setABTestsEvaluation(allExperiments);

    if (this.isMobile) {
        hadFuncs.addAdSlot(MID_AD_BANNER_MOBILE, [320, 50], false, 'n');
    }

    // All Right Rail ads behind abacus
    const evaluateRightRailUnit = evaluateExperimentAndLog(
        HA_ADS_SERP_RIGHTRAIL_300X600
    );
    const rightRailValue = evaluateRightRailUnit.value;

    if (
        this.screenWidth >= RIGHT_RAIL_AD_XL_VIEWPORT_MIN_WIDTH &&
        rightRailValue === 1
    ) {
        hadFuncs.addAdSlot(MID_AD_TOWER, [300, 600], true);
    } else if (
        this.screenWidth >= RIGHT_RAIL_AD_XL_VIEWPORT_MIN_WIDTH &&
        rightRailValue === 2
    ) {
        hadFuncs.addAdSlot(MID_AD_TOWER, [300, 250], true);
    } else if (
        this.screenWidth >= RIGHT_RAIL_AD_XL_VIEWPORT_MIN_WIDTH &&
        rightRailValue === 3
    ) {
        hadFuncs.addAdSlot(MID_AD_TOWER, [300, 250], true);
        hadFuncs.addAdSlot(MID_AD_TOWER_2, [300, 250], true);
    } else if (this.screenWidth >= RIGHT_RAIL_AD_VIEWPORT_MIN_WIDTH) {
        hadFuncs.addAdSlot(MID_AD_TOWER, [160, 600], true);
    }

    // Inline Ads
    const evaluateNativeUnitMobile = evaluateExperimentAndLog(
        HA_ADS_NATIVE_UNIT_SERP_MOBILE
    );
    const evaluateNativeUnitDesktop = evaluateExperimentAndLog(
        HA_ADS_NATIVE_UNIT_SERP_DESKTAB
    );

    SERP_INLINE_ADS.forEach((id, index) => {
        const dfpReportingKey = index + 1;
        if (
            (evaluateNativeUnitMobile.value === 1 && this.isMobile) ||
            evaluateNativeUnitDesktop.value === 1
        ) {
            hadFuncs.addAdSlot(id, ['fluid'], dfpReportingKey, 'n');
        } else if (this.siteName !== VRBO && !this.isMobile) {
            hadFuncs.addAdSlot(id, [728, 90], dfpReportingKey, 'n');
        }
    });
}

export const configureHAdvertising = (
    data: AdSenseConfigData,
    cb: () => void
) => {
    hadvertising = require('@homeaway/hadvertising');

    /* istanbul ignore next */
    hadvertising.ready((hadFuncs) => {
        onHAdvertisingReady.bind(data)(hadFuncs);
        cb();
    });
};

export const updateAdvertising = () => {
    hadvertising.hadFuncs.refreshAds();
};

export const updateDisplayAds = () => {
    hadvertising.hadFuncs.displayAds();
};

export const getAdSenseConfig = (): GoogleAdConfig => {
    return {
        container: AD_ID,
        colorText: '#555555',
        colorDomainLink: '#2a6ebb',
        colorTitleLink: '#0094CE',
        colorBackground: '#FFFFFF',
        fontSizeTitle: 14,
        fontSizeDescription: 12,
        fontSizeDomainLink: 12,
        longerHeadlines: true,
        detailedAttribution: true,
        number: 10
    };
};
